"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerabilityEffectHandler = exports.VulnerabilityEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const AttributeType_1 = require("../../enums/AttributeType");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const MaxAttributeDecrease_1 = require("./MaxAttributeDecrease");
class VulnerabilityEffectArgs {
    constructor(stacks) {
        this.stacks = stacks;
        this.__type = EffectType_1.EffectType.Vulnerability;
        this.__typeName = "Vulnerability";
        this.name = "Vulnerability";
        this.harmful = true;
    }
}
exports.VulnerabilityEffectArgs = VulnerabilityEffectArgs;
let VulnerabilityEffectHandler = class VulnerabilityEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(AttributeType_1.AttributeType.AllDamageImmunity, state.args.stacks * 5),
            duration: Duration_1.Duration.Permanent,
            hidden: true
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
    }
};
VulnerabilityEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Vulnerability)
], VulnerabilityEffectHandler);
exports.VulnerabilityEffectHandler = VulnerabilityEffectHandler;
